import { render, staticRenderFns } from "./ProductFittingsTable.vue?vue&type=template&id=64f837ea&scoped=true&"
import script from "./ProductFittingsTable.vue?vue&type=script&lang=js&"
export * from "./ProductFittingsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductFittingsTable.vue?vue&type=style&index=0&id=64f837ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f837ea",
  null
  
)

export default component.exports